import { type RefObject, useEffect } from 'react'

type AnyEvent = MouseEvent | TouchEvent

function useOnClickOutside<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T | null>,
  handler: (event: AnyEvent) => void,
  exceptionRef?: RefObject<T | null>,
): void {
  useEffect(() => {
    const listener = (event: AnyEvent) => {
      const el = ref?.current
      const ex = exceptionRef?.current

      if (!el || el.contains(event.target as Node) || ex?.contains(event.target as Node)) {
        return
      }

      handler(event)
    }

    document.addEventListener(`mousedown`, listener)
    document.addEventListener(`touchstart`, listener)

    return () => {
      document.removeEventListener(`mousedown`, listener)
      document.removeEventListener(`touchstart`, listener)
    }
  }, [ref, handler])
}

export default useOnClickOutside
